document.addEventListener('DOMContentLoaded', function () {
    // Ensure the element exists before adding the event listener
    const popupClick = document.getElementById('popup-click');
    const popup = document.getElementById('popup');
    const popupClose = document.getElementById('popup-close');

    if (popupClick) {
      // Show the popup when the trigger element is clicked
      popupClick.addEventListener('click', function () {
        if (popup) {
          popup.style.display = 'block';
          
          setTimeout(function() {
            popup.classList.add('popup-open');
          }, 250); 
          
        }
        document.body.classList.add('productPopup-active');
      });
    }

    if (popupClose) {
      // Close the popup when the close button is clicked
      popupClose.addEventListener('click', function () {
        if (popup) {
          popup.style.display = 'none';
          popup.classList.remove('popup-open');
        }
        document.body.classList.remove('productPopup-active');
      });
    }

    if (popup) {
      // Close the popup when clicking outside the popup content
      popup.addEventListener('click', function (e) {
        if (e.target.id === 'popup') {
        popup.style.display = 'none';
          popup.classList.remove('popup-open');
         document.body.classList.remove('productPopup-active');
        }
      });
    }
  });